import { createMuiTheme } from "@material-ui/core"

import colors from "@/styles/colors"

const defaultTheme = createMuiTheme()

const theme = createMuiTheme({
	palette: {
		background: {
			default: colors.palette.background,
			paper: colors.grayScale[11]
		},
		primary: {
			main: colors.palette.primary
		},
		secondary: {
			main: colors.palette.confirm,
			contrastText: "#FFF"
		},
		info: {
			main: colors.palette.info
		},
		warning: {
			main: colors.palette.warning
		},
		success: {
			main: colors.palette.confirm
		},
		text: {
			primary: colors.grayScale[4]
		}
	},
	overrides: {
		MuiLink: {
			root: {
				color: colors.palette.link,
				"&:hover": {
					color: colors.palette.link,
					opacity: 0.8
				}
			}
		},
		MuiFab: {
			root: {
				boxShadow: "0px 2px 4px rgba(33, 36, 41, 0.08)",
				backgroundColor: colors.grayScale[11]
			}
		},
		MuiDialog: {
			paper: {
				margin: "16px"
			},
			paperFullWidth: {
				width: "calc(100% - 16px)"
			}
		},
		MuiInputLabel: {
			root: {
				fontFamily: "Raleway",
				fontStyle: "normal",
				fontWeight: "normal",
				fontSize: "14px",
				lineHeight: "24px",
				textTransform: "none",
				color: colors.grayScale[4]
			},
			outlined: {
				transform: "translate(10px, 14px) scale(1)"
			}
		},
		MuiOutlinedInput: {
			input: {
				padding: "14px"
			}
		},
		MuiInputBase: {
			inputMultiline: {
				"&::-webkit-scrollbar": {
					cursor: "pointer !important",
					width: "6px !important",
					height: "6px !important"
				},
				"&::-webkit-scrollbar-thumb": {
					backgroundColor: "rgba(0, 0, 0, 0.2)"
				},
				"&::-webkit-scrollbar-track": {
					background: "hsla(0, 0%, 100%, 0.1)"
				}
			},
			input: {
				"&[disabled]": {
					backgroundColor: "rgba(0, 0, 0, 0.03) !important"
				}
			}
		},
		MuiButton: {
			root: {
				padding: 8,
				textTransform: "none"
			}
		}
	},
	typography: {
		fontFamily: "Raleway",
		h1: {
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "calc(.95rem * 2.5)",
			lineHeight: "32px",
			color: colors.grayScale[1]
		},
		h2: {
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "calc(.95rem * 2)",
			lineHeight: "48px",
			color: colors.grayScale[1]
		},
		h3: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "calc(.95rem * 1.75)",
			lineHeight: "24px",
			color: colors.grayScale[1]
		},
		h4: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "calc(.95rem * 1.5)",
			lineHeight: "24px",
			color: colors.grayScale[4]
		},
		h5: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "bold",
			fontSize: "calc(.95rem * 1.25)",
			lineHeight: "16px"
		},
		body1: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "calc(.95rem * 1)",
			lineHeight: "24px",
			color: colors.grayScale[4]
		},
		body2: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "calc(.95rem * 0.95)",
			lineHeight: "24px",
			color: colors.grayScale[4]
		},
		overline: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "24px",
			textTransform: "none",
			color: colors.grayScale[4]
		},
		caption: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: "normal",
			lineHeight: "16px",
			color: colors.grayScale[3]
		},
		button: {
			fontFamily: "Raleway",
			fontStyle: "normal",
			fontWeight: 600,
			fontSize: "1rem",
			lineHeight: "125%"
		}
	},
	shadows: Object.values({
		...defaultTheme.shadows,
		0: "0px 0px 0px rgba(0, 0, 0, 0)",
		1: "0px 2px 4px rgba(33, 36, 41, 0.08)"
		// eslint-disable-next-line
	}) as any
})

export default theme
